import Image from 'next/image';

import { getLinkAriaLabel } from '@/utils/urlUtils';

import type { ContentfulServiceFragment } from '@/graphql/contentful/api';
import { useImageLoader } from '@/hooks/useImageLoader';
import { generateDataTestId } from '@/lib/tests';
import { useRegionProvider } from '@/providers/RegionProvider';

import * as S from './Service.styles';

interface ServicesProps extends ContentfulServiceFragment {
  className?: string;
}

export const Service = ({ className, heading, media, url }: ServicesProps) => {
  const { locale } = useRegionProvider();
  const { loader } = useImageLoader();
  const validUrl = url && url !== '#' ? url : undefined;

  return (
    <S.Wrapper
      $underline={true}
      aria-label={
        validUrl
          ? getLinkAriaLabel(validUrl, locale.code) || heading || undefined
          : undefined
      }
      className={className}
      href={validUrl ?? '#'}
    >
      {media && (
        <S.ImageWrapper>
          <Image
            {...generateDataTestId('banner', 'image')}
            alt={media.title || 'Banner'}
            data-test-id='ServiceImg'
            height={0}
            loader={loader}
            sizes='100vw'
            src={media.url ?? ''}
            style={{ width: '100%', height: 'auto' }}
            width={0}
          />
        </S.ImageWrapper>
      )}
      <S.Label data-test-id='ServiceLabel'>{heading}</S.Label>
    </S.Wrapper>
  );
};
